import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

import { NgbDropdownMenu, NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../services/auth.service';
import { TimezoneService } from '../services/timezone.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.html',
  styleUrls: ['./navbar.scss'],
  standalone: true,
  imports: [RouterModule, NgbDropdownModule, NgbDropdownMenu, NgbTooltipModule]
})
export class Navbar {
  isAuthenticated: boolean = false;

  
  currentZone = '';

  constructor(public authService: AuthService,
    private tzService: TimezoneService
  ) {
    this.isAuthenticated = this.authService.isLoggedIn();
        this.currentZone = this.tzService.timezone();

  }

  zones = [
    { label: 'India', value: 'Asia/Kolkata', flag: 'assets/images/flags/in.png' },
    { label: 'Australia', value: 'Australia/Sydney', flag: 'assets/images/flags/au.png' },
    { label: 'Philippines', value: 'Asia/Manila', flag: 'assets/images/flags/ph.png' }
  ];

  onLogout($event: MouseEvent): void {
    this.authService.loggedOut();
    window.location.reload(); // Refresh the page to reflect logout
  }

  shouldDisplayNavbar(): boolean {
    return this.authService.isLoggedIn();
  }

  changeZone(zone: any) {
    // let val = zone.target.value;
    this.tzService.setTimezone(zone);
    this.currentZone = zone;
  }

  getFlag(zone: string): string {
  const found = this.zones.find(z => z.value === zone);
  return found ? found.flag : 'assets/flags/default.png';
}

getZoneName(zone: string): string {
  const found = this.zones.find(z => z.value === zone);
  return found ? found.label : '';
}

onSelectZone(zone: string) {
  if (zone !== this.currentZone) {
    this.changeZone(zone);  // call only if it’s different
  }
}

}
